const resetState = function({ commit }) {
    commit('RESET')
}

const setTicketCounter = ({ commit }, payload) => {
    commit('SET_TICKET_COUNTER', payload)
}
const setInvoiceTicketCounter = ({ commit }, payload) => {
    commit('SET_INVOICE_TICKET_COUNTER', payload)
}
const setOfficeID = ({ commit }, payload) => {
    commit('SET_OFFICE_ID', payload)
}

export default {
    resetState,
    setTicketCounter,
    setOfficeID,
    setInvoiceTicketCounter,
}
